/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { useActionsBtnContext, usePendingState } from '@finbeat/react-toolkit';
import { pingCrmApi } from 'axios/userApi';
import { t } from 'i18next';
import { useMutation } from 'react-query';
import useApi from './useApi';

export type PingCrmApiCallbackProps =
    | {
          available: true;
      }
    | { available: false; resp: boolean };

export const usePingCrmApiCallback = () => {
    const api = useApi();
    const { addRequest } = useActionsBtnContext();
    const { setPending } = usePendingState();

    const saveChangesWithoutCrmSyncConfirm = (
        variables: (props: PingCrmApiCallbackProps) => void
    ) =>
        addRequest({
            content: t('BackOfficeSaveChangesWithoutCrmSync'),
            confirmCallback: (res) => variables({ available: false, resp: res }),
        });

    const { mutate } = useMutation(
        'pingCrmApi',
        (_: (props: PingCrmApiCallbackProps) => void) => {
            setPending(true);
            return pingCrmApi(api);
        },
        {
            onSuccess: (data, variables) => {
                setPending(false);
                data === 'Work'
                    ? variables({ available: true })
                    : saveChangesWithoutCrmSyncConfirm(variables);
            },
            onError: (_, variables) => {
                setPending(false);
                saveChangesWithoutCrmSyncConfirm(variables);
            },
        }
    );

    return mutate;
};
